import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: 'F', label: 'PF' },
			{ value: 'J', label: 'PJ' },
			{ value: 'G', label: 'OP' },
			{ value: 'L', label: 'LOCAL' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

